import { render, staticRenderFns } from "./EducationalItemDetail.vue?vue&type=template&id=141674ee&scoped=true&"
import script from "./EducationalItemDetail.vue?vue&type=script&lang=js&"
export * from "./EducationalItemDetail.vue?vue&type=script&lang=js&"
import style0 from "./EducationalItemDetail.vue?vue&type=style&index=0&id=141674ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141674ee",
  null
  
)

export default component.exports